var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQr2 = function SvgQr2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "qr-2_svg__Capa_2",
    viewBox: "0 0 43.65 43.65"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr-2_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.78 43.65h-4.46C5.53 43.65.01 38.13.01 31.34v-4.29h5.85v4.29c0 3.56 2.9 6.46 6.46 6.46h4.46zM5.85 16.49H0v-4.17C0 5.52 5.52 0 12.31 0h4.46v5.85h-4.46a6.47 6.47 0 0 0-6.46 6.46v4.17ZM43.65 16.49H37.8v-4.17c0-3.56-2.9-6.46-6.46-6.46h-4.11V0h4.11c6.79 0 12.31 5.52 12.31 12.31v4.17Z",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.53 33.77c.53-.53.53-1.4 0-1.93l-2.08-2.08a1.37 1.37 0 0 0-1.93 0l-1.72 1.72-3.48-3.53c1.05-1.8 1.66-3.88 1.66-6.12 0-6.71-5.44-12.15-12.15-12.15S9.68 15.12 9.68 21.83s5.44 12.15 12.15 12.15c2.36 0 4.56-.68 6.43-1.85l8.34 8.34c.4.42.95.66 1.53.66h1.8c.79 0 1.42-.64 1.42-1.42v-1.8c0-.57-.23-1.12-.64-1.51l-.87-.84-.04-.04 1.74-1.74ZM15.52 21.83a6.31 6.31 0 1 1 12.62 0 6.31 6.31 0 0 1-12.62 0",
    fill: "#500d76"
  }))));
};
export default SvgQr2;